import { app } from '../../../app';
import { Controller } from './policies.controller';

app.component('policies', {
    bindings:{
        settings:'<',
    },
    controller: Controller,
    templateUrl: require('./policies.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/policies.component.js